export default __webpack_public_path__ + "static/media/SpringRolls.047d1f48.jpg";